import styled from '@emotion/styled';

export const NikeDropDown = styled.div`
  height: 45px;
  min-height: 70px;
`;

export const TextItem = styled.div`
  height: 60px;
  position: relative;
`;

export const TextItemSearch = styled.div`
  height: 60px;
  padding-top: 8px;
`;

export const IconItem = styled.div`
  opacity: .65
  height: 15px
  width: 15px
`;

export const ModalHeaderIcon = styled.div`
  svg {
    width: 50px;
    height: 50px;
  }
`;
